module.exports = __webpack_public_path__ + "static/img/图层36.d52309a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层36.png
// module id = 6eG5
// module chunks = 0